// extracted by mini-css-extract-plugin
export default {"detail-multi-row":"eEO3XmEOjNertMXk5COW","multi-row-value":"faaesV_gDetSjQ3ckhHw","number-row":"HlJ97sjKYzuQY0KW_51r"};